import { fetchBase, arrayResponseHandler, rejectEmptyResponseAbove } from '../'
import gql from 'graphql-tag'

export const noteHistoryAttrsFragment = gql`
  fragment noteHistoryAttrs on NoteHistory {
    id
    __typename
    createdAt
    from
    to
    noteId
    op
    userIds
  }
`

export default {
  fetchNoteHistory({ apiEndpoint, apiToken }, { noteId }) {
    return fetch(`${apiEndpoint}/notes/${noteId}/history`, {
      ...fetchBase({ apiToken }),
    }).then(arrayResponseHandler)
  },

  revertNoteHistory({ apiEndpoint, apiToken }, { noteId, to }) {
    return fetch(`${apiEndpoint}/notes/${noteId}/history/revert/${to}`, {
      ...fetchBase({ apiToken }),
      method: 'POST',
    }).then(rejectEmptyResponseAbove(400))
  },
}
